import { InstalledApplication } from '@era/locations-sdk';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const InstalledApplicationsResolverActions = createActionGroup({
  source: 'Installed Applications Resolver',
  events: {
    'Installed applications requested': emptyProps(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const InstalledApplicationsApiActions = createActionGroup({
  source: 'Installed Applications API',
  events: {
    'Installed Applications loaded': props<{ installedApplications: InstalledApplication[] }>(),
    'Installed Applications loaded error': props<{ error: ErrorModel }>(),
  },
});
